export default "__VITE_ASSET__BXAkq9Ba__"